import { DataBean } from "../../DataBean";


export class ImpHealthOrphanDisease extends DataBean {

    public async importHealthOrphanDiseaseCatalog(idHealthIDType: any, media: any, mediaContext: any,datastore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importHealthOrphanDiseaseCatalog_Number_String_String_String", [idHealthIDType, media, mediaContext,datastore]);
    }

}